// Copyright (C) 2021 TANNER AG

import React from "react";
import { Paragraph } from "../styleguide";
import { Markdown } from "../components";
import { Link } from "react-router-dom";
import ListItem from "../components/ListItem";

const LinkRenderer = ({ href, children }) => {
    if (href.startsWith("http")) {
        return (
            <a href={href} target="_blank" style={{ color: "rgb(228, 0, 69)", textDecoration: "none" }}>
                {children}
            </a>
        );
    }

    return (
        <Link to={href} style={{ color: "rgb(228, 0, 69)", textDecoration: "none" }}>
            {children}
        </Link>
    );
};

const EMobilityMarkdown = ({ content }) => {
    return (
        <Markdown
            source={content}
            renderers={{
                paragraph: (props) => <Paragraph className="emobility-typo">{props.children}</Paragraph>,
                listItem: (props) => (
                    <ListItem classes={{ listTextStyle: "emobility-typo" }}>{props.children}</ListItem>
                ),
                link: LinkRenderer,
            }}
        />
    );
};

export default EMobilityMarkdown;



// WEBPACK FOOTER //
// ./src/emobility/EMobilityMarkdown.js